window.addEventListener('DOMContentLoaded', () => {

  const loadEventClick = () => {

    const buttonCloseModal = document.querySelectorAll('.close-modal-js');

    buttonCloseModal.forEach((buttonClose) => {
      buttonClose.addEventListener('click', validateVideoBefore)
    })
    const buttonsTag = getButtonsCurrents();
    buttonsTag.forEach((button) => {
      button.addEventListener('click', changeButtonClick)
    });

  }

  const validateVideoBefore = (e) => {

    const buttonClose = e.currentTarget;

    const parentVideo = buttonClose.closest('.nav-carousel-pdp__item-video');
    const video = parentVideo.querySelector('video');
    video.pause();
    restartButtons()
  }

  const changeButtonClick = (e) => {
    const currentButton = e.currentTarget;

    const isActive = currentButton.dataset.active;
    currentButton.dataset.active = isActive === 'true' ? 'false' : 'true';

    if (isActive === 'true') {
      currentButton.dataset.active = 'false';
      document.querySelector('body').style.overflow = 'scroll';

      return
    }

    restartButtons();
    currentButton.dataset.active = 'true';
    if (currentButton.dataset.scroll !== 'true') {
      document.querySelector('body').style.overflow = 'hidden';
    }

    
    if (currentButton.dataset.video === "true") {
      const parentVideo = currentButton.closest('.nav-carousel-pdp__wrapper');
      const video = parentVideo.querySelector('.buttonjs-js[data-active="true"] + .carousel__modal video');
      video.play();
      video.muted = false;
    }

  }

  const getButtonsCurrents = () => {
    return document.querySelectorAll('.buttonjs-js');
  }

  const restartButtons = () => {
    const buttons = getButtonsCurrents();
    buttons.forEach((button) => {
      button.dataset.active = 'false';
    });
    document.querySelector('body').style.overflow = 'scroll';

  }

  loadEventClick();
});